import { ItemLimit } from "@glamcorner/gc-types/lib/subscription";
import React, { useState } from "react";
import ItemsPerMonthContainer from "./containers/ItemsPerMonthContainer";
import PlansContainer from "./containers/PlansCotainer";

import { filterPlansByItemLimit, itemLimitAggregate } from "../../common/service/plan";

import "./choosePlanContainer.scss";


const ChoosePlanContainer: React.FC = () => {
  const itemLimits = itemLimitAggregate();
  const [itemLimitSelected, setItemLimitSelected] = useState<ItemLimit>(itemLimits[1]);
  const plans = filterPlansByItemLimit(itemLimitSelected);

  return (
    <>
      <ItemsPerMonthContainer
        itemLimits={itemLimits}
        selected={itemLimitSelected}
        onClick={(items) => setItemLimitSelected(items)}
      />
      <PlansContainer
        plans={plans}
        onSubmit={(planId) =>
          (window.parent.location.href = `${window.parent.location.origin}/premium/index/payment?plan=${planId}`)
        }
      />
    </>
  );
};

export default ChoosePlanContainer;
